import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// si tu as ajouté la fonction :
import { listVisibleCategories } from "../services/publicProductService";
// sinon, tu peux remplacer par listPublicCategories puis filtrer côté client

function CategorySkeleton() {
  return (
    <div className="col-6 col-sm-4 col-md-3 col-lg-2">
      <div className="card h-100 shadow-sm">
        <div className="ratio ratio-1x1 bg-light placeholder-glow">
          <div className="w-100 h-100" />
        </div>
        <div className="card-body py-2">
          <div className="placeholder col-8" />
        </div>
      </div>
    </div>
  );
}

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const list = await listVisibleCategories(); // visible === true
        // si tu utilises listPublicCategories :
        // const all = await listPublicCategories();
        // const list = (all || []).filter(c => c.visible === true)
        //   .sort((a,b)=> String(a.name||"").localeCompare(String(b.name||""), "fr", {sensitivity:"base"}));
        setCats(Array.isArray(list) ? list : []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="container py-4">
      {/* Bandeau header simple */}
      <section className="p-3 p-md-4 rounded-3 bg-light mb-4 border">
        <div className="d-flex flex-column flex-md-row align-items-md-center gap-3">
          <div className="flex-grow-1">
            <h1 className="h4 mb-1">Catégories</h1>
            <p className="mb-0 text-muted">Découvrez nos univers — prêt-à-porter, accessoires et plus</p>
          </div>
        </div>
      </section>

      {/* Grille responsive */}
      {loading ? (
        <div className="row g-3 g-sm-3 g-md-4">
          {Array.from({ length: 12 }).map((_, i) => <CategorySkeleton key={i} />)}
        </div>
      ) : cats.length === 0 ? (
        <div className="alert alert-light">Aucune catégorie visible pour le moment.</div>
      ) : (
        <div className="row g-3 g-sm-3 g-md-4">
          {cats.map((c) => {
            const href = `/catalogue?categoryId=${encodeURIComponent(c.id || c.slug)}`;
            const img = (c.image && String(c.image).trim()) ? c.image : null;

            return (
              <div
                key={c.id || c.slug}
                className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex"
              >
                <Link
                  to={href}
                  className="card h-100 w-100 text-decoration-none shadow-sm category-card"
                  title={c.name}
                >
                  <div className="ratio ratio-1x1 bg-white">
                    {img ? (
                      <img
                        src={img}
                        alt={c.name}
                        loading="lazy"
                        className="w-100 h-100"
                        style={{ objectFit: "cover" }}
                        onError={(e) => {
                          e.currentTarget.src = "https://via.placeholder.com/512?text=Image";
                        }}
                      />
                    ) : (
                      <div
                        className="w-100 h-100 d-flex align-items-center justify-content-center bg-light text-muted"
                        style={{ fontSize: 12 }}
                      >
                        Pas d’image
                      </div>
                    )}
                  </div>
                  <div className="card-body py-2 text-center">
                    <div className="fw-semibold text-dark text-truncate">
                      {c.name || "—"}
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      )}

      {/* Styles locaux pour un peu d’effet au survol */}
      <style>{`
        .category-card {
          transition: transform .18s ease, box-shadow .18s ease;
          border: 0;
        }
        .category-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0,0,0,.08);
        }
        @media (min-width: 1400px) {
          /* densifier un peu sur les écrans XL si tu veux 6 par ligne */
          .col-lg-2 { flex: 0 0 auto; width: 16.6667%; }
        }
      `}</style>
    </div>
  );
}
